module.exports = __webpack_public_path__ + "img/loading.40c3039.png";